import { render } from "./LikeTitle.vue?vue&type=template&id=ffb0c956&scoped=true"
import script from "./LikeTitle.vue?vue&type=script&lang=js"
export * from "./LikeTitle.vue?vue&type=script&lang=js"

import "./LikeTitle.vue?vue&type=style&index=0&id=ffb0c956&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb0c956"]])

export default __exports__